/* 这个文件是 tools/gen-copy.mjs 生成的，不要手改。
   改文案请改 docs/copy/*.yaml，改规则请改 tools/copy-lint/rules.json，然后跑 make generate-copy。 */

/** 单个变量值的字数上限。变量是填空，不是让模型在这儿写一段话。 */
export const MAX_VALUE_RUNES = 200

/** 术语黑名单：左边不许出现，右边是该写成什么。 */
export const BANNED_TERMS: ReadonlyArray<readonly [string, string]> = [
  ["CPU 使用率", "「很闲」「一直在忙」「快扛不住了」"],
  ["CPU使用率", "「很闲」「一直在忙」「快扛不住了」"],
  ["磁盘使用率", "「硬盘还宽裕」「硬盘有点满了」「硬盘快满了」"],
  ["内存使用率", "「内存够用」「内存有点紧」"],
  ["磁盘空间不足", "「硬盘快满了」，再说清多久会写不进新数据"],
  ["该操作不可逆", "「这一步碰到钱了，得你点一下」"],
  ["操作不可逆", "「这一步碰到钱了，得你点一下」"],
  ["此操作无法撤销", "「这一步碰到钱了，得你点一下」"],
  ["权限不足", "「我不敢自己改——万一你有别的程序正靠这个连着」"],
  ["没有权限", "说清是谁不敢动、为什么不敢动"],
  ["服务不可用", "「小食堂点单刚才断了 3 分钟，现在好了」这种说法"],
  ["服务异常", "说清哪个项目、断了多久、影响谁"],
  ["系统异常", "说清哪一步出了什么事"],
  ["未知错误", "说清卡在哪一步。真不知道就说「我再试试」"],
  ["操作成功", "说清干了什么，比如「我清掉了 12GB 旧日志」"],
  ["部署成功", "「部署好了，可以去测了」"],
  ["执行失败", "说清哪一步失败、接下来怎么办"],
  ["请求超时", "说清等了多久、在等谁"],
  ["参数错误", "说清哪一项不对、该填什么"],
  ["请联系管理员", "这个产品只有一个用户，没有管理员可联系"],
  ["请稍后重试", "说清要等多久，或者干脆自己重试"],
  ["加载中", "说清在等什么"],
  ["磁盘占用", "「硬盘用了多少」"],
  ["内存占用", "「内存用了多少」"],
  ["disk usage", "人话"],
  ["CPU usage", "人话"],
  ["completed successfully", "人话"],
]

/**
 * Unicode Extended_Pictographic 的码点区间，外加变体选择符与零宽连接符。
 *
 * 这里刻意不用 /\p{Extended_Pictographic}/u：Go 那端的 regexp 不认这个类，
 * 而两端必须逐字节一致。用生成时定死的同一张表，两端就不会因为各自的
 * Unicode 版本不同而给出不同结论。
 */
export const EMOJI_RANGES: ReadonlyArray<readonly [number, number]> = [
  [0x00A9, 0x00A9],
  [0x00AE, 0x00AE],
  [0x200D, 0x200D],
  [0x203C, 0x203C],
  [0x2049, 0x2049],
  [0x20E3, 0x20E3],
  [0x2122, 0x2122],
  [0x2139, 0x2139],
  [0x2194, 0x2199],
  [0x21A9, 0x21AA],
  [0x231A, 0x231B],
  [0x2328, 0x2328],
  [0x2388, 0x2388],
  [0x23CF, 0x23CF],
  [0x23E9, 0x23F3],
  [0x23F8, 0x23FA],
  [0x24C2, 0x24C2],
  [0x25AA, 0x25AB],
  [0x25B6, 0x25B6],
  [0x25C0, 0x25C0],
  [0x25FB, 0x25FE],
  [0x2600, 0x2605],
  [0x2607, 0x2612],
  [0x2614, 0x2685],
  [0x2690, 0x2705],
  [0x2708, 0x2712],
  [0x2714, 0x2714],
  [0x2716, 0x2716],
  [0x271D, 0x271D],
  [0x2721, 0x2721],
  [0x2728, 0x2728],
  [0x2733, 0x2734],
  [0x2744, 0x2744],
  [0x2747, 0x2747],
  [0x274C, 0x274C],
  [0x274E, 0x274E],
  [0x2753, 0x2755],
  [0x2757, 0x2757],
  [0x2763, 0x2767],
  [0x2795, 0x2797],
  [0x27A1, 0x27A1],
  [0x27B0, 0x27B0],
  [0x27BF, 0x27BF],
  [0x2934, 0x2935],
  [0x2B05, 0x2B07],
  [0x2B1B, 0x2B1C],
  [0x2B50, 0x2B50],
  [0x2B55, 0x2B55],
  [0x3030, 0x3030],
  [0x303D, 0x303D],
  [0x3297, 0x3297],
  [0x3299, 0x3299],
  [0xFE0F, 0xFE0F],
  [0x1F000, 0x1F0FF],
  [0x1F10D, 0x1F10F],
  [0x1F12F, 0x1F12F],
  [0x1F16C, 0x1F171],
  [0x1F17E, 0x1F17F],
  [0x1F18E, 0x1F18E],
  [0x1F191, 0x1F19A],
  [0x1F1AD, 0x1F1E5],
  [0x1F201, 0x1F20F],
  [0x1F21A, 0x1F21A],
  [0x1F22F, 0x1F22F],
  [0x1F232, 0x1F23A],
  [0x1F23C, 0x1F23F],
  [0x1F249, 0x1F3FA],
  [0x1F400, 0x1F53D],
  [0x1F546, 0x1F64F],
  [0x1F680, 0x1F6FF],
  [0x1F774, 0x1F77F],
  [0x1F7D5, 0x1F7FF],
  [0x1F80C, 0x1F80F],
  [0x1F848, 0x1F84F],
  [0x1F85A, 0x1F85F],
  [0x1F888, 0x1F88F],
  [0x1F8AE, 0x1F8FF],
  [0x1F90C, 0x1F93A],
  [0x1F93C, 0x1F945],
  [0x1F947, 0x1FAFF],
  [0x1FC00, 0x1FFFD],
]

/** 判断「数字/英文紧贴中文」时认的中文区间。 */
export const CJK_RANGES: ReadonlyArray<readonly [number, number]> = [
  [0x4E00, 0x9FFF],
  [0x3400, 0x4DBF],
]

/** 报错文案。两端共用同一批句子，{0} {1} 按位置替换。 */
export const MESSAGES = {
  emoji: "文案里不许出现 emoji",
  bannedTerm: "出现了「{0}」。改写成{1}",
  digitSpacing: "「{0}」数字与中文之间要留一个空格",
  latinSpacing: "「{0}」英文与中文之间要留一个空格",
  unknownTemplate: "没有「{0}」这条模板。句子只能来自 docs/copy/，不许现编",
  missingVar: "「{0}」缺变量 {1}",
  unexpectedVar: "「{0}」没有 {1} 这个变量",
  emptyValue: "变量 {0} 是空的，填出来会是一句缺字的话",
  controlChar: "变量 {0} 里有换行或者控制符。变量是一个词，不是一段话",
  tooLong: "变量 {0} 有 {1} 个字，超过了 {2} 个。变量是填空，不是在这儿写文章",
  valueEmoji: "变量 {0} 里有 emoji",
  valueBannedTerm: "变量 {0} 里出现了「{1}」。改写成{2}",
} as const
